import type { Dispatch, SetStateAction } from "react";
import type { Account, ExpenseInput, Trip } from "../../types";
import { inferCurrencyForDestination } from "../../lib/countries";
import { getDefaultTripAccount, getTripAccounts } from "../../lib/trips";
import TripPicker from "../../components/TripPicker";

export interface EntryTripFieldsProps {
  input: ExpenseInput;
  setInput: Dispatch<SetStateAction<ExpenseInput>>;
  trips: Trip[];
  accounts: Account[];
}

export default function EntryTripFields({
  input,
  setInput,
  trips,
  accounts,
}: EntryTripFieldsProps) {
  const curTrip = trips.find((t) => t.id === input.tripId);

  return (
    <div className="trip-form-section">
      <TripPicker
        label="Trip"
        trips={trips}
        value={input.tripId || ""}
        emptyOption={{ value: "", label: "None (Household)" }}
        onChange={(tid) => {
          const tripId = tid || undefined;
          const selectedT = trips.find((t) => t.id === tripId);
          const curTripAccs = selectedT ? getTripAccounts(selectedT, accounts, trips) : [];
          const isCurInTrip = curTripAccs.some((a) => a.id === input.accountId);
          const nextAccId =
            !isCurInTrip && selectedT && curTripAccs.length > 0
              ? getDefaultTripAccount(selectedT, accounts, undefined, trips, input.type)?.id || input.accountId
              : input.accountId;
          const nextAcc = accounts.find((a) => a.id === nextAccId);
          const autoDest =
            (selectedT && nextAcc
              ? selectedT.destinations.find((d) => inferCurrencyForDestination(d) === nextAcc.currency)
              : undefined) ||
            (selectedT?.destinations.length === 1 ? selectedT.destinations[0] : undefined);
          setInput((v) => ({ ...v, tripId, tripDestination: autoDest, accountId: nextAccId }));
        }}
      />
      {curTrip && curTrip.destinations.length > 1 && (
        <div className="trip-leg-chips">
          <small>Country leg:</small>
          <div className="destination-chips">
            {curTrip.destinations.map((d) => (
              <button
                key={d}
                type="button"
                className={`tag-chip ${input.tripDestination === d ? "active" : ""}`}
                onClick={() => setInput((v) => ({ ...v, tripDestination: d }))}
              >
                {d}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
